/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.12
 */

/**
 * Latitude
 */
export type ReportCoordinatesDtoLatitude = { [key: string]: unknown };
